import { useParams } from 'react-router'
import { useContext, useEffect, useLayoutEffect, useState } from 'react'
import './GalleryDetail.css'

import { GalleryContext } from '../Gallery'
import { MDBCarousel, MDBCarouselCaption, MDBCarouselItem, MDBContainer, MDBRow } from 'mdb-react-ui-kit'
import { MDBEcommerceGallery } from 'mdb-react-ecommerce-gallery'
import ReactImageGallery from 'react-image-gallery'

interface carouselPhotosModel {
    thumbnail: string
    original: string
    originalHeight: string
}



export const GalleryDetail = () => {

    const galleryContent = useContext(GalleryContext)

    const gallery = galleryContent?.newsList

    if (gallery === undefined) {
        return null
    }

    let { id } = useParams()

    const album = gallery[Number(id)]?.imgs

    if (!album) return null

    const heading = gallery[Number(id)]?.heading

    const carouselPhotos_: Array<carouselPhotosModel> = []


    const x = album.filter(
        (val, index) => val !== undefined
    ).map(
        (val) => ({
            thumbnail: val,
            original: val
        })
    );

    return (
        <>

            <MDBContainer className={'border border-0 border-danger bg-light'}>
                <MDBContainer className={'border border-0 border-success p-0 mb-5'}>
                    <p className={'text-muted pt-2 fs-1'}>{heading}</p>
                    <ReactImageGallery items={x} />
                </MDBContainer>
                <MDBContainer className={'border border-0 border-danger py-0'}></MDBContainer>
            </MDBContainer>
        </>
    )
}